import React from "react";
import bannerImg from "../../Assets/Cow-contact-banner.png";
import "./ContactStaticBanner.css";

const StaticBanner = () => {
  return (
    <section className="contact-vf-wrapper">
      <div className="contact-vf-bg"></div>

      <div className="contact-vf-content-wrapper">
        
        {/* Left Text */}
        <div className="contact-vf-text anim anim-top">
  <h1>Get in Touch With Us</h1>
  <p>
    Have questions about our dairy products or need assistance? We’re here to
    help. Reach out to Vangal Farms for enquiries, orders, collaborations, or
    support — our team will get back to you at the earliest.
  </p>
</div>
        {/* Right Image */}
        <div className="contact-vf-image anim anim-bottom">
          <img src={bannerImg} alt="cow" />
        </div>
      </div>
    </section>
  );
};

export default StaticBanner;
